import { css } from '@emotion/react'

export const headerContainerStyle = css`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
  margin-bottom: 8px;
`

export const headerContentStyle = css`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
`

export const avatarStyle = css`
  width: 40x;
  height: 40px;
  border-radius: 50%;
  border: 1px white solid;
  object-fit: contain;
  align-self: center;
`

export const userInfoColumnStyle = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

export const userNameRowStyle = css`
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
`

export const postToRowStyle = css`
  margin-top: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`
